//import CreateTrip from "../../pages/create-trip/oldcreatetrip";
import TripDetails from "../../pages/trip-details";
//import CreateTripPage from "../../pages/create-trip";
import CreateTripWizard from "../../pages/create-trip/v2/create-tripv2";
export var TripManagement_Routes = [
    {
        PATH: "create",
        COMPONENT: CreateTripWizard,
        isProtected: true,
    },
    /* {
      PATH: "create2",
      COMPONENT: CreateTripWizard,
      isProtected: true,
    }, */
    {
        PATH: "edit/:tripId",
        COMPONENT: CreateTripWizard,
        isProtected: true,
    },
    {
        PATH: ":tripId",
        COMPONENT: TripDetails,
        isProtected: false,
    },
];
